module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar customNavbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_c('img', {
    staticClass: "logoClass",
    attrs: {
      "src": "/static/logo.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_vm._v("Inicio")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.about()
      }
    }
  }, [_vm._v("Nosotros")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItemSelected"
  }, [_vm._v("Productos")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.news()
      }
    }
  }, [_vm._v("Noticias")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.contact()
      }
    }
  }, [_vm._v("Contacto")]), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Cerrar Sesión")]) : _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Iniciar Sesión")])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v("Productos")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameSearch),
      expression: "nameSearch"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('nameSearch')
    },
    attrs: {
      "type": "text",
      "name": "nameSearch"
    },
    domProps: {
      "value": (_vm.nameSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameSearch = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nameSearch')),
      expression: "errors.has('nameSearch')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('nameSearch')))])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button customButton",
    on: {
      "click": _vm.getProducts
    }
  }, [_vm._v("Buscar")]), _vm._v(" "), _c('button', {
    staticClass: "button customButton",
    on: {
      "click": _vm.cleanNameSearch
    }
  }, [_vm._v("Limpiar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  })]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('aside', {
    staticClass: "menu customMenu"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, [_vm._l((_vm.productTypeList), function(productType) {
    return _c('li', [_c('a', {
      staticClass: "menuLink customMenuItem",
      on: {
        "click": function($event) {
          _vm.searchType(productType)
        }
      }
    }, [_vm._v(_vm._s(productType))])])
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "menuLink customMenuItem",
    on: {
      "click": _vm.cleanTypeSearch
    }
  }, [_vm._v("Todos")])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "column is-10"
  }, [_c('div', {
    staticStyle: {
      "max-height": "650px",
      "min-height": "305px",
      "overflow-y": "scroll",
      "overflow-x": "hidden"
    }
  }, _vm._l((_vm.productList), function(line) {
    return _c('div', {
      staticClass: "tile is-ancestor"
    }, _vm._l((line.products), function(prodItem) {
      return _c('div', {
        staticClass: "tile is-parent"
      }, [_c('article', {
        staticClass: "tile is-child box"
      }, [(prodItem != null) ? _c('p', {
        staticClass: "title is-4"
      }, [_vm._v(_vm._s(prodItem.title))]) : _vm._e(), _vm._v(" "), (prodItem.orientationH) ? [(prodItem.firstImage != null) ? _c('img', {
        staticClass: "productImageH",
        attrs: {
          "src": _vm.multimediaBase + prodItem.firstImage,
          "align": "center"
        }
      }) : _vm._e()] : [(prodItem.firstImage != null) ? _c('img', {
        staticClass: "productImageV",
        attrs: {
          "src": _vm.multimediaBase + prodItem.firstImage,
          "align": "left"
        }
      }) : _vm._e()], _vm._v(" "), (prodItem != null) ? _c('p', {
        staticClass: "productInfo",
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(prodItem.message))]) : _vm._e(), _vm._v(" "), (prodItem != null) ? _c('router-link', {
        staticClass: "productLink",
        attrs: {
          "to": {
            path: '/products/' + prodItem.id
          }
        }
      }, [_vm._v("Más info")]) : _vm._e()], 2)])
    }))
  }))])])]), _vm._v(" "), _c('FooterComponent')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-832557ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductsComponent.vue
// module id = 88
// module chunks = 0